import { Stack } from "@/theme/index";
import type { ValidReportTypes } from "@/utils/helperTypes";
import {
  ListAction,
  type MenuItem,
  MonitorAction,
  MoreAction,
  PdfAction,
  SaveAction,
} from "src/v2";

type ReportActionsProps = {
  reportType: ValidReportTypes | string;
  reportPermaLink: string;
  reportTitle?: string;
  deleteCurrentReport?: (permalink: string) => void;
};

export const ReportActions: React.FC<ReportActionsProps> = ({
  reportTitle,
  reportType,
  reportPermaLink,
  deleteCurrentReport,
}) => {
  const filterMenuItems = (items: MenuItem[]) => {
    return items.filter(
      (item) => item.display === "Notes" || item.display === "Delete",
    );
  };
  return (
    <Stack direction="row" spacing={1}>
      <SaveAction
        reportPermaLink={reportPermaLink}
        onReportCard
        disableCollapse
      />
      {reportType !== "username" && (
        <MonitorAction
          reportPermaLink={reportPermaLink}
          reportType={reportType}
          onReportCard
          disableCollapse
        />
      )}
      <ListAction
        reportTitle={reportTitle || ""}
        reportPermalink={reportPermaLink}
        onReportCard
        disableCollapse
      />
      <PdfAction
        reportPermalink={reportPermaLink}
        onReportCard
        disableCollapse
      />

      <>
        <MoreAction
          filterMenuItems={filterMenuItems}
          deleteCurrentReport={deleteCurrentReport as () => void}
          reportPermaLink={reportPermaLink}
          reportType={reportType}
          onReportCard
          disableCollapse
        />
      </>
    </Stack>
  );
};
